<template>
	<v-row class="d-flex flex-column">
		<v-col>
			<h4 class="text-h4 font-weight-bold primary--text text--lighten-5 mb-4">{{ muayThai.title }}</h4>
			<game-rating class="my-4"></game-rating>
		</v-col>

		<v-flex class="d-flex justify-sm-start justify-center mb-4 pa-3">
			<v-btn width="130" class="mr-2" outlined color="primary lighten-2">Free Play</v-btn>
			<v-btn width="130" class="ml-2" color="secondary darken-5">Play Now</v-btn>
		</v-flex>

		<v-col>
			<span class="text-body-1 font-weight-light grey--text"> {{ muayThai.gameDescription }} </span>
		</v-col>

		<v-col class="text-left">
			<h6 class="text-h6 primary--text text--lighten-5 mb-4">Game themes</h6>
			<game-themes></game-themes>
		</v-col>
	</v-row>
</template>

<script>
export default {
	data() {
		return {}
	},
	components: {
		"game-rating": require("../common/gameRating").default,
		"game-themes": require("../common/gameThemes").default,
	},
	computed: {
		muayThai() {
			return this.$store.getters["Casino/muayThai"]
		},
	},
}
</script>

<style></style>
